import { useEffect, useRef } from "react";
import { CATEGORY_LABELS } from "./constants";
import { trackAdvertiser } from "./trackAdvertiser";

export function SponsorCard({ advertiser, onInquire, compact }) {
  const advertiserId = advertiser?.id;
  const tracked = useRef(false);
  useEffect(() => {
    if (!advertiserId || tracked.current) return;
    tracked.current = true;
    trackAdvertiser(advertiserId, "view");
  }, [advertiserId]);
  if (!advertiser) return null;
  const hasLink = Boolean(advertiser.destination_url);
  const handleClick = () => {
    trackAdvertiser(advertiser.id, "click");
    if (!hasLink) onInquire(advertiser);
  };
  return (
    <div data-testid={`sponsor-card-${advertiser.id}`} className="rounded-xl border border-[#E7E4DE] bg-white p-4 flex flex-col gap-3 h-full">
      {advertiser.logo_url ? <img src={advertiser.logo_url} alt="" className="h-10 object-contain self-start" /> : <div className="h-10 w-10 rounded-lg bg-[#F8F7F4] grid place-items-center text-sm font-serif-display text-[#667085]">{advertiser.business_name?.[0] || "?"}</div>}
      <div className="flex-1">
        <span className="text-[10px] font-mono uppercase tracking-[.14em] text-[#C7A361]">Sponsored</span>
        <p className="font-medium text-[#202833] text-sm mt-1">{advertiser.business_name}</p>
        <p className="text-[11px] text-[#667085] mt-0.5">{CATEGORY_LABELS[advertiser.category] || advertiser.category}{advertiser.service_area ? ` · ${advertiser.service_area}` : ""}</p>
        {!compact && advertiser.description && <p className="text-xs text-[#667085] mt-2 line-clamp-3">{advertiser.description}</p>}
      </div>
      {hasLink
        ? <a data-testid={`sponsor-card-cta-${advertiser.id}`} href={advertiser.destination_url} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="inline-flex items-center justify-center rounded-lg bg-[#C7A361] text-[#111820] text-xs font-medium py-2 hover:brightness-95 transition">{advertiser.button_label || "Visit Website"}</a>
        : <button data-testid={`sponsor-card-cta-${advertiser.id}`} onClick={handleClick} className="inline-flex items-center justify-center rounded-lg bg-[#C7A361] text-[#111820] text-xs font-medium py-2 hover:brightness-95 transition">{advertiser.button_label || "Contact Business"}</button>}
      {advertiser.disclosure_text && <p className="text-[10px] text-[#94A3B8] leading-snug">{advertiser.disclosure_text}</p>}
    </div>
  );
}
